<div [ngClass]="loadingClass">
  <mat-spinner [diameter]="size"></mat-spinner>
</div>
